

import {
    FilterList as Filter,
    Add as Plus
} from '@mui/icons-material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

interface ArcHeaderProps {
  onToggleFilters: () => void;
  activeFilterCount: number;
  onCreateArc: () => void;
}

export function ArcHeader({
  onToggleFilters,
  activeFilterCount,
  onCreateArc,
}: ArcHeaderProps) {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        borderBottom: 1,
        borderColor: 'divider',
        bgcolor: 'background.paper',
        p: 2,
      }}
    >
      <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
        <Typography variant="h5" component="h1" sx={{ fontWeight: 700 }}>
          {t('arcs.title')}
        </Typography>

        <Stack direction="row" spacing={2} alignItems="center">
          {/* Filter Toggle Button */}
          <Button
            variant={activeFilterCount > 0 ? 'contained' : 'outlined'}
            onClick={onToggleFilters}
            size="small"
            startIcon={<Filter sx={{ fontSize: 18 }} />}
          >
            {t('arcs.filters')}
            {activeFilterCount > 0 && (
              <Chip
                label={activeFilterCount}
                size="small"
                color="primary"
                sx={{
                  ml: 1,
                  height: 20,
                  fontSize: '0.7rem',
                  bgcolor: 'white',
                  color: 'primary.main',
                }}
              />
            )}
          </Button>

          {/* Create New Arc Button */}
          <Button
            variant="contained"
            startIcon={<Plus sx={{ fontSize: 18 }} />}
            onClick={onCreateArc}
          >
            {t('arcs.new_arc')}
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
}
